<template>

  <div id="ts-nav" :class="[{show: showNavbar},{white: white}]">

    <div class="container">
				<div class="col-sm-12 col-md-1 col-lg-1">
          <router-link to="/">
            <transition name="slide-up-in" appear>
            <svg id="logo" width="52px" height="52px" viewBox="0 0 52 52">
                <g id="Main-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                    <g transform="translate(-73.000000, -58.000000)" stroke="#101016" stroke-width="1.75">
                        <g transform="translate(74.000000, 59.000000)">
                            <polygon points="12.4811594 37.8914744 37.1438406 37.8914744 37.1438406 13.3546747 12.4811594 13.3546747"></polygon>
                            <g transform="translate(0.000000, 0.191409)">
                                <path d="M49.648913,24.9570351 C49.648913,38.5470964 38.5753623,49.5648473 24.9148551,49.5648473 C11.2550725,49.5648473 0.18115942,38.5470964 0.18115942,24.9570351 C0.18115942,11.3666133 11.2550725,0.34922287 24.9148551,0.34922287 C38.5753623,0.34922287 49.648913,11.3666133 49.648913,24.9570351 Z"></path>
                                <path d="M7.58297101,42.5102064 L42.6735507,7.829434"></path>
                                <path d="M23.8783729,37.7001733 L37.1438406,24.1045405"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
          </transition>
          </router-link>
        </div>

        <div class="name-container col-sm-12 offset-md-1 col-md-11 offset-lg-1 col-lg-11">
          <transition name="slide-up-in" appear>
          <div class="name">
            <p><span>Aaron Nicholls</span></br>Digital Product Designer</p>
          </div>
          </transition>
        </div>

        <div class="ts-nav-routes">

          <transition name="slide-up-in" appear>
            <router-link class="nav works" to="/works">Works</router-link>
          </transition>

          <transition name="slide-up-in" appear>
            <router-link class="nav about" to="/about">About</router-link>
          </transition>

          <transition name="slide-up-in" appear>
            <a class="nav email" href="mailto:hello@tiny-square.design">Say Hello<span></span></a>
          </transition>
        </div>
    </div>

  </div>

</template>

<script>

import TsImage from '@/components/TSImage.vue'
import ImageScroll from "@/assets/images/scroll-down.svg"

export default {

  name: 'TsNav',

  data () {
    return {
      showNavbar: true,
      white: false,
      lastScrollPosition: 0,
      ImageScroll: {
        url: ImageScroll,
        size: [14,113],
        bgColor: "none"
      }
    }
  },

  components: {
    TsImage
  },

  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },

  methods: {
    onScroll () {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) return;
      // add shadow when not at the top of the page
      this.white = currentScrollPosition > 0;
      if (currentScrollPosition > 0) {
        this.$root.$emit('scrolling', true);
      } else {
        this.$root.$emit('scrolling', false);
      }

      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
      // emit that we are scrolling
    }
  }

}

</script>
